<template>
  <DetailTemplate
    :customClass="'supplier-detail detail-page'"
    v-if="getPermission('supplier:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex px-0">
          <Status :status="customerActivated"></Status>
        </div>
        <div class="px-2 py-5 text-center">
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="image"
          >
          </v-skeleton-loader>
          <template v-else>
            <v-img
              :lazy-src="$defaultProfileImage"
              :src="getProfileImage ? getProfileImage : $defaultProfileImage"
              aspect-ratio="1"
              max-height="140"
              max-width="140"
              class="margin-auto custom-grey-border custom-border-radius-50"
              transition="fade-transition"
            >
            </v-img>
          </template>
        </div>
        <div class="">
          <table class="width-100">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Supplier Information
              </th>
            </tr>
          </table>
          <ContactDetail
            :pageLoading="pageLoading"
            :supplier="supplierArr"
          ></ContactDetail>
          <template v-if="getPermission('supplier:update')">
            <span key="0" class="mt-2 d-block text-center">
              <v-skeleton-loader
                class="custom-skeleton d-inline-block custom-skeleton-full-width"
                v-if="pageLoading"
                type="button"
                height="28"
                width="200"
              >
              </v-skeleton-loader>
              <v-btn
                v-else
                class="custom-bold-button"
                small
                depressed
                v-on:click.native.stop="detailDialog = true"
              >
                <v-icon dark color="cyan" left>mdi-pencil</v-icon>Update
                Supplier Details
              </v-btn>
            </span>
          </template>
        </div>
      </v-card>
    </template>
    <template v-slot:header-title>
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        width="400"
        height="28"
        type="text"
      >
      </v-skeleton-loader>
      <h1 class="form-title custom-nowrap-ellipsis text-capitalize">
        {{ getPageTitle }}
      </h1>
    </template>
    <template v-slot:header-action>
      <template v-if="getPermission('supplier:update')">
        <v-menu
          transition="slide-y-transition"
          bottom
          content-class="custom-menu-list"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-bind="attrs"
              v-on="on"
              depressed
            >
              More... <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template v-for="(more, index) in supplierMoreAction">
              <v-list-item
                link
                v-on:click="updateMoreAction(more.action)"
                :key="index"
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-500 font-size-14">{{
                  more.title
                }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="goBack"
        depressed
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
    </template>
    <template v-slot:body>
      <v-container fluid class="px-0">
        <v-tabs
          v-model="supplierTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent sticky-tab-0"
        >
          <template v-for="(tab, index) in tabs">
            <v-tab
              class="font-size-16 font-weight-600 px-8"
              :key="index"
              :href="'#' + tab.key"
              :disabled="tab.disabled"
            >
              <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                <!--begin::Svg Icon-->
                <inline-svg
                  :src="$assetURL('media/custom-svg/' + tab.key + '.svg')"
                />
                <!--end::Svg Icon-->
              </span>
              {{ tab.title }}
            </v-tab>
          </template>
        </v-tabs>
        <!-- <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll"
          style="max-height: 89vh position: relative"
        > -->
        <v-tabs-items v-model="supplierTab">
          <v-tab-item v-if="getPermission('property:view')" :value="'property'">
            <v-row justify="center">
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <template v-slot:default="{ open }">
                      <v-row no-gutters>
                        <v-col cols="4" class="margin-auto">
                          <h2
                            class="margin-auto color-custom-blue font-size-20 font-weight-700"
                          >
                            Contact Persons
                          </h2>
                        </v-col>
                        <v-col cols="8">
                          <span v-if="open" key="0">
                            <template
                              v-if="getPermission('contact-person:create')"
                            >
                              <span class="float-right">
                                <v-skeleton-loader
                                  class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                  v-if="pageLoading"
                                  type="button"
                                  height="28"
                                  width="200"
                                >
                                </v-skeleton-loader>
                                <v-btn
                                  v-else
                                  class="mx-2 mr-4 custom-bold-button white--text"
                                  color="cyan"
                                  small
                                  depressed
                                  v-on:click.native.stop="personDialog = true"
                                >
                                  <v-icon dark left>mdi-plus</v-icon>Create
                                  Contact Person
                                </v-btn>
                              </span>
                            </template>
                            <template v-if="personSelectedRows.length > 0">
                              <template
                                v-if="getPermission('contact-person:update')"
                              >
                                <span class="float-right">
                                  <v-skeleton-loader
                                    class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                    v-if="pageLoading"
                                    type="button"
                                    height="28"
                                    width="150"
                                  >
                                  </v-skeleton-loader>
                                  <v-menu
                                    v-else
                                    :close-on-click="true"
                                    bottom
                                    content-class="custom-menu-list"
                                    offset-y
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        class="mx-2 custom-bold-button white--text"
                                        color="cyan"
                                        small
                                        depressed
                                      >
                                        <v-icon small dark left
                                          >mdi-chevron-down</v-icon
                                        >Bulk Action
                                      </v-btn>
                                    </template>
                                    <v-list>
                                      <template
                                        v-for="(
                                          item, index
                                        ) in personBulkActions"
                                      >
                                        <template>
                                          <template
                                            v-if="
                                              (item.action == 'default' &&
                                                personSelectedRows.length ==
                                                  1) ||
                                              item.action != 'default'
                                            "
                                          >
                                            <v-list-item
                                              :key="index"
                                              link
                                              v-on:click="
                                                updateSupplierPerson(item)
                                              "
                                            >
                                              <v-list-item-title
                                                class="font-weight-400 my-2 font-size-14"
                                                >{{
                                                  item.title
                                                }}</v-list-item-title
                                              >
                                            </v-list-item>
                                          </template>
                                        </template>
                                      </template>
                                    </v-list>
                                  </v-menu>
                                </span>
                              </template>
                            </template>
                          </span>
                        </v-col>
                      </v-row>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ContactPerson
                      :pageLoading="pageLoading"
                      :supplier="supplierArr"
                      v-on:selectSupplier="showUpdateDialog"
                      v-on:selectedRows="updatePersonSelectedRows"
                    ></ContactPerson>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <template v-slot:default="{ open }">
                      <v-row no-gutters>
                        <v-col cols="6" class="margin-auto">
                          <h2
                            class="margin-auto color-custom-blue font-size-20 font-weight-700"
                          >
                            Supplier Address
                          </h2>
                        </v-col>
                        <v-col cols="6">
                          <span v-if="open" key="0" class="float-right">
                            <template v-if="getPermission('supplier:update')">
                              <v-skeleton-loader
                                class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                v-if="pageLoading"
                                type="button"
                                height="28"
                                width="200"
                              >
                              </v-skeleton-loader>
                              <v-btn
                                v-else
                                class="mx-2 mr-4 custom-bold-button white--text"
                                color="cyan"
                                small
                                depressed
                                v-on:click.native.stop="billingDialog = true"
                              >
                                <v-icon dark left>mdi-pencil</v-icon>Update
                                Supplier Address
                              </v-btn>
                            </template>
                          </span>
                        </v-col>
                      </v-row>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <BillingAddress
                      :pageLoading="pageLoading"
                      :supplier="supplierArr"
                    ></BillingAddress>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-col md="12" lg="12">
                <v-card
                  flat
                  class="custom-grey-border remove-border-radius mb-4 h-100"
                >
                  <v-card-title class="headline grey lighten-4 py-1">
                    <span
                      class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                    >
                      Remark</span
                    >
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <span>
                      <template v-if="supplierArr.supplier_remark">
                        {{ supplierArr.supplier_remark }}
                      </template>
                      <template v-else>
                        <em class="text--secondary font-weight-500"
                          >no remark</em
                        >
                      </template>
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>
              <CustomFormDetail
                v-if="supplierArr.id"
                module="supplier"
                :module-id="supplierArr.id"
              />
            </v-row>
          </v-tab-item>
          <v-tab-item v-if="getPermission('product:view')" :value="'product'">
            <Products type="supplier" :detail="supplierArr"></Products>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('purchase-order:view')"
            :value="'purchase-order'"
          >
            <PurchaseOrder
              type="supplier"
              :detail="supplierArr"
            ></PurchaseOrder>
          </v-tab-item>
          <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <InternalHistoryDetail
              type="supplier"
              :type_id="supplierArr.id"
            ></InternalHistoryDetail>
          </v-tab-item>
        </v-tabs-items>
        <!-- </perfect-scrollbar> -->
      </v-container>
    </template>
    <template v-slot:footer>
      <Dialog
        v-if="detailDialog"
        :commonDialog="detailDialog"
        :dialogWidth="1024"
      >
        <template v-slot:title>Update Supplier Details</template>
        <template v-slot:body>
          <v-form
            :class="{
              'pointer-events-none': !getPermission('supplier:update'),
            }"
            ref="supplierDetailForm"
            v-model.trim="detailForm"
            lazy-validation
            v-on:submit.stop.prevent="onDetailSubmit('supplierDetailForm')"
          >
            <DialogContactDetails
              :supplier="supplierArr"
              :isDialog="true"
              :options="options"
              v-on:saveContactDetail="updateContactDetail"
            >
            </DialogContactDetails>
          </v-form>
        </template>
        <template v-slot:action>
          <template v-if="getPermission('supplier:update')">
            <v-btn
              depressed
              :disabled="!detailForm || formLoading"
              :loading="formLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-on:click="onDetailSubmit('supplierDetailForm')"
              >Update
            </v-btn>
          </template>
          <v-btn
            depressed
            :disabled="formLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="masterDialogClose"
            >Close
          </v-btn>
        </template>
      </Dialog>
      <Dialog
        v-if="personDialog"
        :commonDialog="personDialog"
        :dialogWidth="768"
      >
        <template v-slot:title
          ><span v-if="personId > 0">Update</span>
          <span v-else>Create</span>&nbsp;Contact Person</template
        >
        <template v-slot:body>
          <v-form
            :class="{
              'pointer-events-none': !getPermission('contact-person:update'),
            }"
            ref="supplierPersonForm"
            v-model.trim="personForm"
            lazy-validation
            v-on:submit.stop.prevent="onDetailSubmit('supplierPersonForm')"
          >
            <DialogContactPersons
              :supplier="supplierArr"
              :isDialog="true"
              :person="personId"
              v-on:saveContactPerson="updateContactPerson"
            >
            </DialogContactPersons>
          </v-form>
        </template>
        <template v-slot:action>
          <template v-if="getPermission('contact-person:update')">
            <v-btn
              depressed
              :disabled="!personForm || formLoading"
              :loading="formLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-on:click="onDetailSubmit('supplierPersonForm')"
            >
              <span v-if="personId > 0">Update</span>
              <span v-else>Create</span>
            </v-btn>
          </template>
          <v-btn
            depressed
            :disabled="formLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="masterDialogClose"
            >Close
          </v-btn>
        </template>
      </Dialog>
      <Dialog
        v-if="billingDialog"
        :commonDialog="billingDialog"
        :dialogWidth="1024"
      >
        <template v-slot:title>Company Address</template>
        <template v-slot:body>
          <v-form
            :class="{
              'pointer-events-none': !getPermission('supplier:update'),
            }"
            ref="billingForm"
            v-model.trim="billingForm"
            lazy-validation
            v-on:submit.stop.prevent="onDetailSubmit('billingForm')"
          >
            <DialogBillingAddress
              :supplier="supplierArr"
              :isDialog="true"
              :property="propertyAddress"
              :billing="1"
              v-on:saveBillingAddress="updateBillingAddress"
            >
            </DialogBillingAddress>
          </v-form>
        </template>
        <template v-slot:action>
          <template v-if="getPermission('supplier:update')">
            <v-btn
              depressed
              :disabled="!billingForm || formLoading"
              :loading="formLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-on:click="onDetailSubmit('billingForm')"
              >Update
            </v-btn>
          </template>
          <v-btn
            depressed
            :disabled="formLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="masterDialogClose"
            >Close
          </v-btn>
        </template>
      </Dialog>
    </template>
  </DetailTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  PUT,
  PATCH,
  CLEAR_ERROR,
  GET,
} from "@/core/services/store/request.module";
import ContactDetail from "@/view/pages/supplier/detail/overview/Contact-Detail.vue";
import ContactPerson from "@/view/pages/supplier/detail/overview/Contact-Person.vue";
import BillingAddress from "@/view/pages/supplier/detail/overview/Billing-Address.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import DialogContactDetails from "@/view/pages/supplier/create-or-update/Contact-Details.vue";
import DialogContactPersons from "@/view/pages/supplier/create-or-update/Contact-Persons.vue";
import DialogBillingAddress from "@/view/pages/supplier/create-or-update/Billing-Address-New.vue";
import SupplierMixin from "@/core/plugins/supplier-mixin";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import PatchSupplierMixin from "@/core/lib/supplier/patch.supplier.mixin";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import PurchaseOrder from "@/view/pages/partials/Detail/PurchaseOrder.vue";
import Products from "@/view/pages/partials/Detail/Products";
import Status from "@/view/pages/partials/Status.vue";
import CustomFormDetail from "@/view/pages/custom-field-v2/CustomFormDetail.vue";
import { SET_ACTIVE_FIELD_DATA } from "@/core/services/store/custom.fields.module.js";
export default {
  mixins: [CommonMixin, ValidationMixin, SupplierMixin, PatchSupplierMixin],
  name: "supplier-detail",
  title: "Supplier",
  data() {
    return {
      supplierTab: "property",
      supplier: 0,
      serviceFormDialog: false,
      pageLoading: true,
      deleteDialog: false,
      supplierArr: {},
      tabs: [
        {
          title: "Overview",
          icon: "mdi-phone",
          key: "property",
          disabled: false,
        },
        {
          title: "Products / Parts",
          icon: "mdi-credit-card",
          key: "product",
          disabled: false,
        },
        /* {
          title: "Purchase Order",
          icon: "mdi-credit-card",
          key: "purchase-order",
          disabled: false,
        }, */
        {
          title: "History",
          icon: "mdi-credit-card",
          key: "history",
          disabled: false,
        },
      ],
      supplierMoreAction: [
        {
          title: "Mark as Active",
          icon: "mdi-check-all",
          action: "active",
        },
        {
          title: "Mark as In-Active",
          icon: "mdi-check-all",
          action: "inactive",
        },
      ],
      //supplierTab: null,
      panel: [0, 1],
      personSelectedRows: [],
      propertySelectedRows: [],
      propertyAddress: {},
      billingAddress: {},
      contactDetail: {},
      options: {},
      contactPerson: [],
      notification: {},
      detailForm: true,
      detailDialog: false,
      formLoading: false,
      personId: 0,
      personForm: true,
      personDialog: false,
      propertyId: 0,
      propertyForm: true,
      propertyDialog: false,
      billingForm: true,
      billingDialog: false,
      notificationForm: true,
      notificationDialog: false,
    };
  },
  components: {
    ContactDetail,
    ContactPerson,
    BillingAddress,
    Dialog,
    DialogContactDetails,
    DialogContactPersons,
    DialogBillingAddress,
    DetailTemplate,
    PurchaseOrder,
    Products,
    InternalHistoryDetail,
    Status,
    CustomFormDetail,
  },
  watch: {
    panel() {
      this.masterDialogClose();
    },
  },
  methods: {
    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "supplier/options" })
        .then(({ data }) => {
          _this.options = data.options;
          _this.options.all_cms_categories = data.all_cms_categories;
        })
        .catch((error) => {
          _this.logError(error);
        });
      /*.finally(() => {
          _this.$refs.supplierForm.validate();
        });*/
    },
    updateMoreAction(action) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
      }
      _this
        .patchSupplier(_this.supplier, formData)
        .then(() => {
          _this.getSupplier().then((response) => {
            _this.supplierArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    updateBillingAddress(param) {
      this.billingAddress = param;
    },
    updateContactDetail(param) {
      this.contactDetail = param;
    },
    updateContactPerson(param) {
      this.contactPerson = param;
    },
    updatePersonSelectedRows(param) {
      this.bulkRows = { persons: param };
      this.personSelectedRows = param;
    },
    updatePropertySelectedRows(param) {
      this.bulkRows = { property: param };
      this.propertySelectedRows = param;
    },
    updateSupplierPerson({ action }) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
        case "default":
          formData.default = 1;
          break;
      }
      _this
        .patchSupplierContactPerson(
          _this.supplier,
          _this.personSelectedRows,
          formData
        )
        .then(() => {
          _this.getSupplier().then((response) => {
            _this.supplierArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    updateSupplierProperty({ action }) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
      }
      _this
        .patchSupplierProperty(
          _this.supplier,
          _this.propertySelectedRows,
          formData
        )
        .then(() => {
          _this.getSupplier().then((response) => {
            _this.supplierArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    async onDetailSubmit(formRef) {
      const _this = this;

      try {
        if (!_this.$refs[formRef].validate()) {
          return false;
        }

        _this.pageLoading = true;
        _this.formLoading = true;
        _this.$store.dispatch(CLEAR_ERROR, {});

        let formData = new Object();
        let personFormData = new Object();
        let detailFormData = new Object();
        let addressFormData = new Array();

        if (_this.contactDetail.uen && _this.contactDetail.uen.length < 3) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("The uen must be between 3 and 50 characters")
          );
          _this.formLoading = false;
          _this.pageLoading = false;
          return false;
        }
        if (_this.lodash.isEmpty(_this.contactDetail) === false) {
          for (let key in _this.contactDetail) {
            formData[key] = _this.contactDetail[key];
          }

          if (_this.lodash.isEmpty(formData.profile_logo) === false) {
            formData.profile_logo = formData.profile_logo.id;
          }
        }

        if (_this.lodash.isEmpty(_this.contactDetail) === false) {
          if (
            Object.prototype.hasOwnProperty.call(
              _this.contactDetail,
              "details"
            ) &&
            _this.lodash.isEmpty(_this.contactDetail.details) === false
          ) {
            detailFormData = _this.contactDetail.details;
          }
        }
        if (_this.contactDetail?.category?.color) {
          formData.category_color = _this.contactDetail?.category?.color
            ? _this.contactDetail?.category?.color
            : null;
        }
        if (_this.contactDetail?.category?.text) {
          formData.category = _this.contactDetail?.category?.text
            ? _this.contactDetail?.category?.text
            : null;
        }
        if (_this.lodash.isEmpty(_this.contactPerson) === false) {
          personFormData = _this.contactPerson;
        }

        if (_this.lodash.isEmpty(_this.billingAddress) === false) {
          addressFormData.push(_this.billingAddress);
        }

        //formData = _this.lodash.pickBy(formData, _this.lodash.identity);
        addressFormData = _this.lodash.pickBy(
          addressFormData,
          _this.lodash.identity
        );

        if (_this.lodash.isEmpty(formData) === false) {
          await _this.$store.dispatch(PATCH, {
            url: "supplier/" + _this.supplier,
            data: formData,
          });
        }

        if (_this.lodash.isEmpty(personFormData) === false) {
          await _this.$store.dispatch(PUT, {
            url: "supplier/" + _this.supplier + "/contact-person",
            data: { persons: personFormData },
          });
        }

        if (_this.lodash.isEmpty(detailFormData) === false) {
          await _this.$store.dispatch(PUT, {
            url: "supplier/" + _this.supplier + "/detail",
            data: { details: detailFormData },
          });
        }

        if (_this.lodash.isEmpty(addressFormData) === false) {
          await _this.$store.dispatch(PUT, {
            url: "address/" + _this.supplier,
            data: { address: addressFormData, type: "supplier" },
          });
        }

        _this
          .getSupplier()
          .then((response) => {
            _this.supplierArr = response;
            _this.masterDialogClose();
            if (Array.isArray(this.supplierArr.custom_fields)) {
              this.$store.commit(
                SET_ACTIVE_FIELD_DATA,
                this.supplierArr.custom_fields
              );
            }
          })
          .finally(() => {
            _this.formLoading = false;
            _this.pageLoading = false;
          });
      } catch (error) {
        _this.formLoading = false;
        _this.pageLoading = false;
        ErrorEventBus.$emit("update:error", InitializeError(error));
      }
    },
    showUpdateDialog(param) {
      this.personId = param;
      this.personDialog = true;
    },
    masterDialogClose() {
      this.$root.$emit("clearSelection", true);
      this.personSelectedRows = [];
      this.propertySelectedRows = [];
      this.propertyAddress = {};
      this.billingAddress = {};
      this.contactDetail = {};
      this.contactPerson = [];
      this.notification = {};
      this.detailForm = true;
      this.detailDialog = false;
      this.formLoading = false;
      this.personId = 0;
      this.personForm = true;
      this.personDialog = false;
      this.propertyId = 0;
      this.propertyForm = true;
      this.propertyDialog = false;
      this.billingForm = true;
      this.billingDialog = false;
      this.notificationForm = true;
      this.notificationDialog = false;
      this.deleteDialog = false;
    },
  },
  mounted() {
    const _this = this;
    _this.checkTabPermission();
    _this
      .getSupplier()
      .then((response) => {
        _this.supplierArr = response;
        _this.getOptions();
        _this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Supplier", route: "supplier" },
          { title: "Detail" },
          { title: response.barcode },
        ]);
        if (Array.isArray(this.supplierArr.custom_fields)) {
          this.$store.commit(
            SET_ACTIVE_FIELD_DATA,
            this.supplierArr.custom_fields
          );
        }
      })
      .catch((error) => {
        _this.logError(error);
        _this.$router.go(-1);
      })
      .finally(() => {
        _this.pageLoading = false;
      });
  },
  created() {
    const _this = this;
    _this.supplier = _this.$route.params.id;
    if (!_this.supplier || _this.supplier <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.supplierTab = _this.$route.query.tab;
    }
  },
  computed: {
    customerActivated() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.supplierArr) === false) {
        return _this.supplierArr.activated;
      }
      return false;
    },
    getProfileImage() {
      if (!this.supplierArr.profile_logo) {
        return null;
      }
      return this.supplierArr.profile_logo.file.url;
    },
    getPageTitle() {
      let result = [];
      if (this.lodash.isEmpty(this.supplierArr) === false) {
        if (this.supplierArr.display_name) {
          result.push(this.supplierArr.display_name);
        }
        // if (this.supplierArr.barcode) {
        //   result.push(this.supplierArr.barcode);
        // }
      }
      return result.join(" • ");
    },
    // supplierTab: {
    //   set(val) {
    //     let query = { ...this.$route.query };
    //     query.tab = val;
    //     if (val != this.supplierTab) {
    //       this.$router.push({ query });
    //     }
    //   },
    //   get() {
    //     return this.$route.query.tab || "supplier";
    //   },
    // },
  },
};
</script>
